<section class="menus-page">
  <div class="menus-card">
    <div class="menus-card__header">
      <div class="menus-card__title">
        <h1>Manage Menu</h1>
      </div>

      <button type="button" class="primary-button" (click)="openCreateForm()">+ Add New</button>
    </div>

    <div class="menus-card__filters">
      <label class="search-field search-field--wide">
        <span>Search</span>
        <div class="input-with-icon">
          <span class="input-icon">⌕</span>
          <input
            type="search"
            placeholder="Search menu name, route, or class..."
            [value]="searchTerm()"
            (input)="onSearch($any($event.target).value)"
          >
        </div>
      </label>

      <label class="search-field search-field--compact">
        <span>Type</span>
        <select [value]="selectedType()" (change)="onTypeChange($any($event.target).value)">
          <option value="ALL">All Types</option>
          <option value="PARENT">Parent</option>
          <option value="CHILD">Child</option>
        </select>
      </label>
    </div>

    @if (toast()) {
      <div class="toast-message" [class.error]="toast()?.type === 'error'" role="status">
        {{ toast()?.message }}
      </div>
    }

    <div class="table-wrap">
      <table class="table-sm menu-table">
        <tr>
          <th>S.NO.</th>
          <th>MENU NAME</th>
          <th>TYPE</th>
          <th>PARENT MENU</th>
          <th>ROUTE URL</th>
          <th>ORDER</th>
          <th>STATUS</th>
          <th>ACTIONS</th>
        </tr>
        @for (menu of menus(); track menu.id; let index = $index) {
          <tr>
            <td>{{ showingStart() + index }}</td>
            <td>
              <div class="menu-name">{{ menu.name }}</div>
              @if (menu.css_class) {
                <div class="menu-meta">{{ menu.css_class }}</div>
              }
            </td>
            <td>
              <span class="type-pill">{{ typeLabel(menu) }}</span>
            </td>
            <td>{{ parentLabel(menu) }}</td>
            <td>{{ menu.route_url || '-' }}</td>
            <td>{{ menu.order_no }}</td>
            <td>
              <span class="status-pill" [class.active]="menu.is_active" [class.inactive]="!menu.is_active">
                {{ statusLabel(menu) }}
              </span>
            </td>
            <td>
              <div class="action-buttons">
                <button type="button" class="action-button edit-button" (click)="edit(menu)" aria-label="Edit menu">
                  ✎
                </button>
                <button type="button" class="action-button delete-button" (click)="remove(menu)" aria-label="Delete menu">
                  🗑
                </button>
              </div>
            </td>
          </tr>
        } @empty {
          <tr>
            <td colspan="8">
              <div class="empty-state">No menus found.</div>
            </td>
          </tr>
        }
      </table>
    </div>

    <div class="pagination-bar">
      <span>Showing {{ showingStart() }} to {{ showingEnd() }} of {{ totalItems() }} results</span>

      <div class="pagination-controls">
        <div class="page-size-box">
          <span>Rows per page</span>
          <select [value]="pageSize()" (change)="onPageSizeChange($any($event.target).value)">
            @for (size of pageSizeOptions; track size) {
              <option [value]="size">{{ size }}/Page</option>
            }
          </select>
        </div>

        <button type="button" class="pagination-arrow" [disabled]="currentPage() === 1" (click)="prevPage()">
          Previous
        </button>

        <div class="page-numbers">
          @for (token of pageTokens(); track $index) {
            @if (token === '...') {
              <span class="pagination-ellipsis">...</span>
            } @else {
              <button
                type="button"
                class="pagination-page"
                [class.active]="currentPage() === token"
                (click)="goToPage(token)"
              >
                {{ token }}
              </button>
            }
          }
        </div>

        <button type="button" class="pagination-arrow" [disabled]="currentPage() === totalPages()" (click)="nextPage()">
          Next
        </button>
      </div>
    </div>
  </div>

  @if (isFormOpen()) {
    <div class="modal-backdrop" role="presentation">
      <section class="menu-modal" role="dialog" aria-modal="true" aria-labelledby="menu-modal-title">
        <div class="menu-modal__header">
          <div>
            <p>{{ editingMenuId() ? 'Edit Menu' : 'Add New Menu' }}</p>
            <h2 id="menu-modal-title">{{ editingMenuId() ? 'Update menu details' : 'Create a new menu item' }}</h2>
          </div>

          <button type="button" class="modal-close" (click)="closeForm()">×</button>
        </div>

        <form class="menu-form" [formGroup]="form" (ngSubmit)="save()">
          <div class="form-grid">
            <label>
              <span>Name</span>
              <input formControlName="name" placeholder="Approval Flow">
            </label>

            <label>
              <span>Class</span>
              <input formControlName="css_class" placeholder="menu-approval-flow">
            </label>

            <label>
              <span>Route / URL</span>
              <input formControlName="route_url" placeholder="/master/approval-flow">
            </label>

            <label>
              <span>Order No</span>
              <input type="number" min="1" formControlName="order_no">
            </label>

            <label class="field--full">
              <span>Parent Menu</span>
              <select formControlName="parent_menu_id">
                <option [ngValue]="0">No parent menu</option>
                @for (menu of parentMenus(); track menu.id) {
                  <option [ngValue]="menu.id">{{ menu.name }}</option>
                }
              </select>
            </label>
          </div>

          <div class="form-actions">
            <button type="button" class="secondary-button" (click)="closeForm()">Cancel</button>
            <button type="submit" class="primary-button" [disabled]="form.invalid">
              {{ editingMenuId() ? 'Update Menu' : 'Create Menu' }}
            </button>
          </div>
        </form>
      </section>
    </div>
  }
</section>
